import { Progress } from "react-sweet-progress";
import { colors } from "../../../lib/design";
import React from "react";
import moment from "moment";
import "./../../app.scss";
import "./campaigns.scss";

const ProgressBase = props => {
  const { daysLeft, clockTimeString, textFn } = props;

  return (
    <div className="flex-row-container align-center">
      <span className="days-to-respond-progress-label margin-right--small">
        {textFn && textFn(daysLeft, clockTimeString)}
      </span>
      <div className={"m-lxs"}>
        <Progress
          type={"circle"}
          percent={((DaysToRespond - daysLeft) / DaysToUpload) * 100}
          width={20}
          strokeWidth={20}
          theme={{
            default: { symbol: " ", trailColor: "rgba(0, 0, 0, 0.1)" },
            success: { symbol: " ", color: colors.primaryColor, trailColor: "rgba(0, 0, 0, 0.1)" },
          }}
          status={"success"}
          style={{ marginBottom: "10px" }}
        />
      </div>
    </div>
  );
};

const DaysToRespond = 6;

export const DaysToRespondProgress = props => {
  const { campaignItem, textFn } = props;

  const respondByAt = moment.unix(campaignItem.respondByAt).utc();
  const currentAt = moment();
  const daysLeft = Math.round(respondByAt.diff(currentAt, "days", true));
  const clockTimeLocal = respondByAt.local().format("hh:mm A");

  return <ProgressBase textFn={textFn} daysLeft={daysLeft} clockTimeString={clockTimeLocal} />;
};

const DaysToUpload = 21;

export const DaysToUploadProgress = props => {
  const { campaignItem, textFn } = props;

  const uploadAudioBy = moment.unix(campaignItem.uploadAudioBy).utc();
  const currentAt = moment();
  const daysLeft = Math.round(uploadAudioBy.diff(currentAt, "days", true));
  const clockTimeLocal = uploadAudioBy.local().format("hh:mm A");

  return <ProgressBase textFn={textFn} daysLeft={daysLeft} clockTimeString={clockTimeLocal} />;
};
